import Vue from 'vue';
import Router from 'vue-router';

import Dashboard from '@/views/Dashboard';
import DashboardProvisioning from '@/views/DashboardProvisioning';
import DashboardWithdrawal from '@/views/DashboardWithdrawal';
import DashboardOrderSummary from '@/views/DashboardOrderSummary.vue';
import Tasks from '@/views/Tasks';
import TaskList from '@/views/TaskList';
import TaskView from '@/views/TaskView';
import PhoneNumberPorting from '@/views/PhoneNumberPorting';
import Provisioning from '@/views/Provisioning';
import TvProvisioning from '@/views/TvProvisioning';
import TvProvisioningDashboard from '@/views/TvProvisioningDashboard';
import ServiceOrder from '@/views/ServiceOrder.vue';
import Statistic from '@/views/Statistic';
import StatistikDashboard from '@/views/StatistikDashboard.vue';
import Withdrawal from '@/views/Withdrawal.vue';
import MenuWrapper from '@/views/MenuWrapper';
import SelocaArticleList from '@/views/SelocaArticleList.vue';
import SelocaOrderHistory from '@/views/SelocaOrderHistory';
import MSANConfig from '@/views/MSANConfig.vue';
import GncConstructionList from '@/views/GncConstructionList';
import SupportStart from '@/views/SupportStart.vue';
import ConstructionProjects from '@/views/ConstructionProjects';
import ConstructionProjectOverview from '@/views/ConstructionProjects/Overview';
import ConstructionProjectOverviewMap from '@/views/ConstructionProjects/OverviewMap';
import NewProject from '@/views/ConstructionProjects/NewProject';
import ConstructionProjectStates from '@/views//ConstructionProjectStates';
import RoutesPermissionOverview from '@/views/RoutesPermissionOverview';
import HomePassedUnblocking from '@/views/HomePassedUnblocking';
import TwoFactorAdmin from '@/views/TwoFactorAdmin';
import Addressmanagement from '@/views/Addressmanagement';
import RadiusSessionLock from '@/views/RadiusSessionLock';
import SavedForSecondConstructionPhaseUnblocking from '@/views/SavedForSecondConstructionPhaseUnblocking';
import OnlineConstructionList from '@/views/OnlineConstructionList';
import OnlineConstructionListStats from '@/views/OnlineConstructionListStats';
import ExternalAccountManager from '@/views/ExternalAccountManager';
import ConstructionAccountManager from '@/views/externalAccount/ConstructionAccountManager';
import SchedulerOverview from '@/views/SchedulerOverview';
import KblUploader from '@/views/KblUploader';

import {
  mdiAccountHardHatOutline,
  mdiAccountDetailsOutline,
  mdiFolderAccount,
  mdiSecurity,
  mdiTimerSync
} from '@mdi/js';

Vue.use(Router);

export const adminGroups = ['camunda-admin', 'LgSpotAdmin'];

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/task-list',
    meta: {
      visible: false
    }
  },
  {
    path: '/task-list-old',
    name: 'Aufgabenliste Alt',
    component: Tasks,
    meta: {
      visible: false
    },
    icon: 'mdi-clipboard-list-outline'
  },
  {
    path: '/task-list',
    name: 'Aufgabenliste',
    component: TaskList,
    meta: {
      visible: true
    },
    icon: 'mdi-clipboard-list-outline'
  },
  {
    path: '/task/:id',
    name: 'Aufgabe',
    component: TaskView,
    meta: {
      visible: false
    }
  },
  {
    path: '/porting-dasboard',
    name: 'Portierung',
    component: Dashboard,
    icon: 'mdi-format-list-bulleted-type',
    meta: {
      visible: true,
      auth: [...adminGroups, 'LgSpotPortierung', 'LgSpotPortierungLeitung']
    }
  },
  {
    path: '/porting',
    name: 'Start Portierung',
    component: PhoneNumberPorting,
    icon: 'mdi-phone-forward-outline',
    meta: {
      visible: true,
      auth: [...adminGroups, 'LgSpotPortierung', 'LgSpotPortierungLeitung']
    }
  },
  {
    path: '/provisioning-dashboard',
    name: 'Provisionierung',
    component: DashboardProvisioning,
    icon: 'mdi-format-list-bulleted-type',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotPortierung',
        'LgSpotProvisionierung',
        'LgSpotProvisionierungLeitung',
        'LgSpotSecondLevel',
        'LgSpotSecondLevelLeitung'
      ]
    }
  },
  {
    path: '/provisioning',
    name: 'Start Provisionierung',
    component: Provisioning,
    icon: 'mdi-lan-pending',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotPortierung',
        'LgSpotProvisionierung',
        'LgSpotProvisionierungLeitung',
        'LgSpotAccess',
        'LgSpotSecondLevel',
        'LgSpotSecondLevelLeitung'
      ]
    }
  },
  {
    path: '/tv-provisioning',
    name: 'Start TV Provisionierung',
    component: TvProvisioning,
    icon: 'mdi-television-classic',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotAuftragserfassung'
      ]
    }
  },
  {
    path: '/tv-provisioning-dashboard',
    name: 'TV Provisionierungen',
    component: TvProvisioningDashboard,
    icon: 'mdi-format-list-bulleted-type',
    meta: {
      visible: true,
      auth: [...adminGroups, 'LgSpotAuftragsmanagement']
    }
  },
  {
    path: '/msanConfig',
    name: 'MSAN Konfiguration',
    component: MSANConfig,
    icon: 'mdi-server-network',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotAccess',
        'LgSpotSecondLevel',
        'LgSpotNoc'
      ]
    }
  },
  {
    path: '/order-dashboard',
    name: 'Auftragseingänge',
    component: DashboardOrderSummary,
    icon: 'mdi-format-list-bulleted-type',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotAuftragserfassung',
        'LgSpotAgentur'
      ]
    }
  },
  {
    path: '/order',
    name: 'Auftragserfassung',
    component: ServiceOrder,
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotAuftragserfassung'
      ]
    },
    icon: 'mdi-file-edit-outline'
  },
  {
    path: '/withdrawal',
    name: 'Start Kündigung & Widerruf',
    component: Withdrawal,
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotAuftragserfassung',
        'LgSpotExternXpronNonVoice'
      ]
    },
    icon: 'mdi-file-cancel-outline'
  },
  {
    path: '/withdrawal-dashboard',
    name: 'withdrawalDashboard',
    component: DashboardWithdrawal,
    icon: 'mdi-format-list-bulleted-type',
    meta: {
      title: 'Kündigung & Widerruf',
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotAuftragserfassung',
        'LgSpotExternXpronNonVoice'
      ]
    }
  },
  {
    path: '/seloca',
    name: 'Seloca',
    component: MenuWrapper,
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagementLeitung',
        'LgSpotAuftragsmanagement',
        'LgSpotFieldservice',
        'LgSpotHotline',
        'LgSpotEinkauf'
      ]
    },
    icon: 'mdi-package-variant',
    children: [
      {
        path: 'articles',
        name: 'Seloca Artikelliste',
        component: SelocaArticleList,
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagementLeitung',
            'LgSpotAuftragsmanagement',
            'LgSpotHotline',
            'LgSpotEinkauf'
          ]
        },
        icon: 'mdi-package-variant'
      },
      {
        path: 'history',
        name: 'Versandhistorie',
        component: SelocaOrderHistory,
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagementLeitung',
            'LgSpotAuftragsmanagement',
            'LgSpotFieldservice'
          ]
        },
        icon: 'mdi-history'
      }
    ]
  },
  {
    path: '/construction-lists',
    name: 'Kundenbaulisten',
    component: MenuWrapper,
    icon: 'mdi-format-list-text',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotKblTest',
        'LgSpotAccess',
        'LgSpotBau',
        'LgSpotBauLeitung',
        'LgSpotFieldservice',
        'LgSpotGnc'
      ]
    },
    children: [
      {
        path: 'online-construction-list',
        name: 'Online KBL',
        component: OnlineConstructionList,
        icon: 'mdi-web-sync',
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagement',
            'LgSpotKblTest',
            'LgSpotNU',
            'LgSpotAccess',
            'LgSpotBau',
            'LgSpotBauLeitung',
            'LgSpotFieldservice'
          ]
        }
      },
      {
        path: 'online-construction-list-stats',
        name: 'Online KBL Übersicht',
        component: OnlineConstructionListStats,
        icon: 'mdi-chart-bar-stacked',
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagement',
            'LgSpotKblTest',
            'LgSpotAccess',
            'LgSpotBau',
            'LgSpotBauLeitung',
            'LgSpotFieldservice'
          ]
        }
      },
      {
        path: 'gnc-construction-list',
        name: 'Excel KBL',
        component: GncConstructionList,
        icon: 'mdi-microsoft-excel',
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagement',
            'LgSpotBau',
            'LgSpotBauLeitung',
            'LgSpotGnc'
          ]
        }
      },
      {
        path: 'kbl-uploader',
        name: 'KBL Uploader',
        component: KblUploader,
        icon: 'mdi-upload',
        meta: {
          visible: true,
          auth: [...adminGroups]
        }
      }
    ]
  },
  {
    path: '/online-kbl',
    name: 'Online Kundenbauliste',
    component: OnlineConstructionList,
    icon: 'mdi-web-sync',
    meta: {
      title: 'Online Kundenbauliste',
      visible: true,
      auth: ['LgSpotNU']
    }
  },
  {
    path: '/construction-projects',
    name: 'Projekte',
    component: ConstructionProjects,
    icon: 'mdi-bulldozer',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotProjekte',
        'LgSpotVertrieb',
        'LgSpotControlling',
        'LgSpotAccess',
        'LgSpotFieldservice',
        'LgSpotBau',
        'LgSpotBauLeitung',
        'LgSpotRegionalLeitung',
        'LgSpotAddressmaster',
        'LgSpotSecondLevel'
      ]
    },
    children: [
      {
        path: 'statistic',
        name: 'Statistik',
        component: Statistic,
        icon: 'mdi-chart-multiple',
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagement',
            'LgSpotProjekte',
            'LgSpotVertrieb',
            'LgSpotControlling',
            'LgSpotSecondLevel'
          ]
        }
      },
      {
        path: 'project-list',
        name: 'Übersicht',
        component: ConstructionProjectOverview,
        icon: 'mdi-format-list-numbered',
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagement',
            'LgSpotIntern',
            'LgSpotProjekte',
            'LgSpotVertrieb',
            'LgSpotControlling',
            'LgSpotRegionalLeitung',
            'LgSpotSecondLevel'
          ]
        }
      },
      {
        path: 'address-management',
        name: 'address-management',
        component: Addressmanagement,
        icon: 'mdi-map',
        meta: {
          title: 'Adressverwaltung',
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagement',
            'LgSpotAddressmaster',
            'LgSpotVertrieb',
            'LgSpotProjekte',
            'LgSpotAccess',
            'LgSpotBau',
            'LgSpotBauLeitung',
            'LgSpotSecondLevel'
          ]
        }
      },
      // {
      //   path: 'tariff-management',
      //   name: 'Tarifverwaltung',
      //   component: TariffManagement,
      //   icon: 'mdi-tag',
      //   meta: {
      //     visible: true,
      //     auth: [
      //       'camunda-admin',
      //       'LgSpotProjekte',
      //       'LgSpotVertrieb',
      //       'LgSpotControlling'
      //     ]
      //   }
      // },
      {
        path: 'new-project',
        name: 'Neues Projekt',
        component: NewProject,
        icon: 'mdi-layers-plus',
        meta: {
          visible: true,
          auth: [...adminGroups]
        }
      },
      {
        path: 'project-state-change',
        name: 'Projekt und Baustatus',
        component: ConstructionProjectStates,
        icon: 'mdi-format-list-numbered',
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAccess',
            'LgSpotBau',
            'LgSpotBauLeitung',
            'LgSpotAuftragsmanagement',
            'LgSpotFieldservice',
            'LgSpotSecondLevel'
          ]
        }
      },
      {
        path: 'home-passed-list',
        name: 'Home-Passed Freigabe',
        component: HomePassedUnblocking,
        icon: 'mdi-format-list-bulleted-type',
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagement',
            'LgSpotGnc',
            'LgSpotBau',
            'LgSpotBauLeitung'
          ]
        }
      },
      {
        path: 'saved-for-second-construction-phase-list',
        name: 'Für zweiten Bauabschnitt gespeichert',
        component: SavedForSecondConstructionPhaseUnblocking,
        icon: 'mdi-format-list-bulleted-type',
        meta: {
          visible: true,
          auth: [...adminGroups, 'LgSpotGnc', 'LgSpotBau', 'LgSpotBauLeitung']
        }
      },
      {
        path: 'map-overview',
        name: 'Übersichtkarte',
        component: ConstructionProjectOverviewMap,
        icon: 'mdi-map-legend',
        meta: {
          visible: true,
          auth: [
            ...adminGroups,
            'LgSpotAuftragsmanagement',
            'LgSpotProjekte',
            'LgSpotVertrieb',
            'LgSpotControlling',
            'LgSpotRegionalLeitung'
          ]
        }
      }
    ]
  },
  {
    path: '/support-start',
    name: 'Start Support',
    component: SupportStart,
    icon: 'mdi-help-network-outline',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotAuftragsmanagement',
        'LgSpotSecondLevel',
        'LgSpotSecondLevelLeitung',
        'LgSpotHotline',
        'LgSpotHotlineLeitung',
        'LgSpotAuftragserfassung',
        'LgSpotExternXpron',
        'LgSpotExternBauermedia',
        'LgSpotBau',
        'LgSpotExternCreditreform'
      ]
    }
  },
  {
    path: '/statistik-dashboard',
    name: 'Reporting',
    component: StatistikDashboard,
    meta: {
      visible: true,
      auth: [...adminGroups, 'LgSpotControlling']
    },
    icon: 'mdi-view-dashboard'
  },
  {
    path: '/external-auth/construction',
    name: 'GU Nutzerverwaltung Bau Backoffice',
    component: ConstructionAccountManager,
    icon: mdiAccountHardHatOutline,
    meta: {
      visible: true,
      auth: ['LgSpotBauPMOAss', ...adminGroups],
      hideForGroups: [...adminGroups]
    }
  },
  {
    path: '/external-auth',
    name: 'Externe Nutzerverwaltung',
    component: ExternalAccountManager,
    icon: mdiFolderAccount,
    meta: {
      visible: true,
      auth: [...adminGroups]
    },
    children: [
      {
        path: 'general',
        name: 'Generelle Verwaltung',
        component: ExternalAccountManager,
        icon: mdiAccountDetailsOutline,
        meta: {
          visible: true,
          auth: [...adminGroups]
        }
      },
      {
        path: 'construction',
        name: 'GU Bau Backoffice',
        component: ConstructionAccountManager,
        icon: mdiAccountHardHatOutline,
        meta: {
          visible: true,
          auth: [...adminGroups]
        }
      }
    ]
  },
  {
    path: '/radius-session-lock',
    name: 'RADIUS Session Lock',
    component: RadiusSessionLock,
    icon: 'mdi-format-list-checks',
    meta: {
      visible: true,
      auth: [
        ...adminGroups,
        'LgSpotBackbone',
        'LgSpotSecondLevelLeitung',
        'LgSpotClearing'
      ]
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: MenuWrapper,
    icon: mdiSecurity,
    meta: {
      title: 'Admin Area',
      visible: true,
      auth: [...adminGroups]
    },
    children: [
      {
        path: 'two-factor-admin',
        name: '2fa-admin',
        component: TwoFactorAdmin,
        icon: 'mdi-qrcode-scan',
        meta: {
          title: 'Zweifaktor-Admin',
          visible: true,
          auth: [...adminGroups]
        }
      },
      {
        path: 'permission-overview',
        name: 'permission-overview',
        component: RoutesPermissionOverview,
        icon: 'mdi-folder-lock-open',
        meta: {
          title: 'Berechtigungsübersicht',
          visible: true,
          auth: [...adminGroups]
        }
      },
      {
        path: 'scheduler',
        name: 'scheduler',
        component: SchedulerOverview,
        icon: mdiTimerSync,
        meta: {
          title: 'Scheduler',
          visible: true,
          auth: [...adminGroups]
        }
      }
    ]
  },

  // {
  //   path: '/statistics',
  //   name: 'Statistik',
  //   component: Statistics,
  //   public: true,
  //   icon: 'mdi-format-list-bulleted-type',
  //   children: [
  //     {
  //       name: 'Adressen',
  //       component: Addresses,
  //       path: ':addresses',
  //       public: true,
  //     }
  //   ]
  // },

  { path: '*', redirect: '/' }
];

const router = new Router({
  routes,
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  window.document.title = `${to.meta?.title ?? to.name} | ${process.env.VUE_APP_TITLE ?? 'Goetel SPOT'
    }`;
  next();
});

export default router;
